<template>
    <main class="mt-5">
        <div class="card mt-3">
            <div class="card-header  border-0">
                <h5 class="card-title font-bold">حواله بین انبار با بارکد</h5>
                <div style="flex:1"></div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex align-items-center" style="gap: 12px;">  
                            <div class="col-4">
                                <label class="mb-0" style="white-space: nowrap;">از</label>  
                                <select 
                                    class="form-control" 
                                    v-model="fromStore" 
                                    @change="clearVarieties" 
                                    >
                                    <option v-for="agency in stores" :value="{id: agency.id,name: agency.label}">{{ agency.label }}</option>  
                                </select>  
                            </div>
                            <div class="col-4">
                                <label class="mb-0" style="white-space: nowrap;">به</label>  
                                <select 
                                    class="form-control" 
                                    v-model="toStore" 
                                    @change="clearVarieties" 
                                    >
                                    <option v-for="agency in stores" :value="{id: agency.id,name: agency.label}">{{ agency.label }}</option>  
                                </select>  
                            </div>
                            <div class="col-4">
                                <label for="" class="mb-0" style="width: 28%;">انتخاب فروشنده</label>
                                <multiselect placeholder="انتخاب کنید" v-model="seller" open-direction="bottom"
                                    :options="sellers" label="full_name" track-by="value" :searchable="true" :close-on-select="true"
                                    :show-labels="true" :disabled="disabled">
                                    <template slot="noOptions">
                                        موردی یافت نشد
                                    </template>
                                    <template slot="noResult">
                                        موردی یافت نشد
                                    </template>
                                </multiselect>
                            </div>
                           
                            <!-- <button class="btn btn-success"   
                                    :disabled="!toStore"   
                                    data-toggle="modal"   
                                    data-target="#add-variety-modal">  
                                <i class="fa fa-plus"></i>  
                            </button>   -->
                        </div>  
                    </div>
                    <div class="col-4 mr-1">
                        <b-form-group label="انتخاب محصول" class="">
                            <b-form-input
                            autocomplete="off"
                            ref="productSku"
                            v-model="productSku"
                            @keypress.prevent.enter="requestProduct"
                            type="text"
                            />
                        </b-form-group>
                    </div>
                </div>
                <div class="row mt-2">
                    <table class="table table-responsive-sm table-bordered table-hover">
                        <thead>
                            <tr>
                                <th>ردیف</th>
                                <th>محصول</th>
                                <th>تنوع</th>
                                <th>بارکد</th>
                                <th>تعداد({{ fromStore ? fromStore.name : '' }})</th>
                                <th>حذف</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(variety,index) in varieties" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ variety.product_title }}</td>
                                <td>
                                      <span v-if="variety.color || variety.attributes != ''">
                                        <span> | </span>
                                        <span v-if="variety.color">
                                            رنگ : {{ variety.color.name }}
                                            {{ variety.attributes != "" ? " | " : "" }}
                                        </span>
                                        <span v-if="variety.attributes != ''">
                                            <span
                                                v-for="(attr, index) in variety.attributes"
                                                :key="index"
                                            >
                                                {{ attr.label + ": " + attr.pivot.value }}
                                                {{
                                                index != variety.attributes.length - 1 ? " | " : ""
                                                }}
                                            </span>
                                        </span>
                                    </span>
                                </td>
                                <td> {{ variety.barcode }}   </td>
                                <td>
                                    {{ variety.quantity_havale }}  
                                </td>
                                <td>
                                    <button  
                                        class="btn btn-sm btn-icon btn-danger text-white"  
                                        data-toggle="tooltip"  
                                        data-original-title="حذف"  
                                        style="margin-inline: 1px"  
                                        @click="deleteVariety(index)">  
                                        <i class="fa fa-trash-o"></i>  
                                    </button>  
                                </td>
                            </tr>
                        </tbody>

                    </table>
                </div>
                <!-- <Loading v-if="$root.isEmptyObject(items)" /> -->
            </div>
            <div class="card-footer" v-if="varieties.length > 0">
                <div class="d-flex justify-content-center align-items-center">
                    <button class="btn btn-success text-right item-right" :disabled="isButtonDisabled" @click="submitData">ارسال</button>
                </div>
            </div>  
        </div>
    </main>
</template>
<script>
    import HavaleBarcodeCreateLmpl from '@@/core/pages/Havale/HavaleBarcodeCreate/HavaleBarcodeCreateLmpl'
    export default {
        extends: HavaleBarcodeCreateLmpl
    }
</script>
<style></style>